export class Queue {
    constructor() {
        this.queue = [];
    }
    add(task) {
        this.queue.push(task);
        return this;
    }
    hasOne() {
        return Boolean(this.queue.length);
    }
    get length() {
        return this.queue.length;
    }
    shift() {
        if (this.hasOne()) {
            const task = this.queue.shift();
            if (task) {
                return task;
            }
        }
        return null;
    }
}
